exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-59b3b801] {\n  max-width: 500px;\n}\n.modal-container .modal-body[data-v-59b3b801] {\n    min-height: 80px;\n    padding: 15px 24px;\n}\n.modal-container .modal-body .form-wrapper[data-v-59b3b801] {\n      position: relative;\n}\n.modal-container .modal-body .form-wrapper .label[data-v-59b3b801] {\n        margin: 10px 0;\n        font-size: 14px;\n        font-weight: bold;\n}\n", ""]);

// exports
